export const ERROR_REQUIRED = 'This field is required.';
export const ERROR_INVALID_URL = 'Please enter a valid URL.';
export const errorMaxChars = (max) => `Maximum ${max} characters.`;
export const errorMaxCharsRecommended = (max) => `Maximum ${max} characters recommended.`;
